import { MapPin } from "lucide-react";
import { SERVICE_AREAS } from "@/lib/business";

export const ServiceAreas = () => {
  const doubled = [...SERVICE_AREAS, ...SERVICE_AREAS];
  return (
    <section
      id="areas"
      data-testid="service-areas-marquee"
      className="relative bg-[#0A0A0A] py-20 border-y border-white/5 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-10 flex items-center gap-3">
        <MapPin className="w-4 h-4 text-[#1E90FF]" strokeWidth={1.5} />
        <span className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#1E90FF]">
          Covering Medway & surrounding areas
        </span>
      </div>

      <div className="relative overflow-hidden">
        <div className="flex marquee-track w-max">
          {doubled.map((area, i) => (
            <div
              key={`${area}-${i}`}
              className="flex items-center gap-8 px-8 shrink-0"
            >
              <span
                className="text-5xl sm:text-6xl lg:text-7xl text-white/80 font-light whitespace-nowrap hover:text-[#1E90FF] transition-colors duration-500"
                style={{ fontFamily: "Outfit" }}
              >
                {area}
              </span>
              <span className="w-2 h-2 bg-[#1E90FF] rounded-full shrink-0" />
            </div>
          ))}
        </div>

        {/* Edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#0A0A0A] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#0A0A0A] to-transparent" />
      </div>
    </section>
  );
};
